var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSaveIcon = function SvgSaveIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#121619",
    d: "M20.125 3.5H7.875a1.75 1.75 0 0 0-1.75 1.75V24.5a.875.875 0 0 0 1.339.742L14 21.156l6.537 4.086a.876.876 0 0 0 1.338-.742V5.25a1.75 1.75 0 0 0-1.75-1.75m0 19.422-5.662-3.539a.88.88 0 0 0-.928 0l-5.66 3.539V5.25h12.25z"
  })));
};
export default SvgSaveIcon;